// 中文
export default {
  confirm: '确认',
  abandon: '放弃',
  nav: {
    aboutUs: '关于我们',
    fundProduct: '基金产品',
    investorInteraction: '投资者互动',
    contactUs: '联系我们',
    news: '全球市场资讯'
  },
  footer: {
    addressLabel: '电子邮件地址:',
    addressValue: 'operation@auroratechs.top'
  },
  aboutUs: {
    introduceLeftTitle: '基金介绍',
    introduceLeftContent: 'FUND APEX是主要投向于全球新兴国家消费信贷类资产,依托领先全球智能科技的金融科技公司(云盾科技)的风控审核系统、AI及算法,深度赋能新兴市场各类银行和持牌金融机构信贷资产撮合业务,在严控风险的情况下向基金筛选更优质组合资产,使其能够从核心发展中国家的数字金融市场发展中受益,以满足高净值投资者在全球产品分配和财富保值增值的需求。',
    introduceRightTitle: '基金管理人',
    introduceRightContent: '极光投资管理公司是一家注册于英国维尔京群岛，符合《证券及投资业务法》管理条例，并由当地《金融服务委员会》批准设立并授予认证的投资管理公司，可从事于全球不同类资产的投资管理活动。',
    licensePlate: '管理人资质/合作伙伴'
  },
  fundProduct: {
    apex: 'APEX基金',
    investmentTerm: '投资期限',
    investmentDate: '12个月',
    minimumInvestment: '投资门槛',
    investmentAmount: '$100,000起',
    investmentDirectionLabel: '投资方向',
    investmentDirection: '资金用于认购全球新兴市场消费信贷类资产优先级份额。',
    investmentHighlights: '投资亮点',
    highlights1One: '目标定位于全球新兴市场，严控风险情况下，使其能够从核心发展中国家的数字金融市场的蓬勃发展中受益。',
    highlights2One: '资产服务方是一支稳定且经验丰富的管理团队，服务于海内外市场各大银行及持牌金融机构。',
    highlights3One: '提供来自全球消费信贷资产, 累计超30亿美金成交额资产可供基金筛选,筛选比例约百一份额。',
    highlights4One: '认购人享有基金优先级份额, 基金结构设置20% 劣后资金，资金安全垫高。'
  },
  investorInteraction: {
    askedQuestionsTitle: '常见问题解答',
    askedSubTitle1: '入门指南',
    askedOne: 'Apex 基金 - FUND APEX SP是什么类型的基金?',
    answerOne1: 'Apex基金是一家依据开曼群岛法律注册的隔离投资组合公司项下其中一个投资组合基金,属于伞形基金。',
    answerOne2: '伞形基金具有一下特点：',
    answerOne3: '结构灵活：子基金独立，伞形基金包含多个子基金，每个子基金独立运作，拥有自己的投资策略和资产。',
    answerOne4: '风险隔离：资产独立：各子基金的资产和负债相互隔离，一个子基金的风险不会影响其他子基金。',
    askedSubTitle2: '投资问题',
    askedTwo: '基金的投向和策略是什么？',
    answerTwo1: '投向：基金资金用于认购全球新兴市场消费信贷类资产优先级份额，底层资产为全球新兴市场消费信贷类资产，主要涉及到东南亚市场，以印尼为主；拉美市场，以墨西哥为主等。',
    answerTwo2: '策略: 依托领先全球智能科技的金融科技公司(云盾科技)的风控审核系统、AI及算法, 深度赋能新兴市场各类银行和持牌金融机构信贷资产撮合业务, 在严控风险的情况下向基金筛选更优质组合资产。',
    askedSubTitle3: '投资要约和选择过程',
    askedThree: '基金有什么样的优势？',
    answerThree1: '主要有四大优势：',
    answerThree2: '市场选择：目标定位于全球新兴市场，例如印尼、墨西哥等国家拥有人口、消费、互联网普及度、数字支付渗透率等优势，在传统银行普及不足的情况下，推动发展中国家的数字金融市场的蓬勃发展。',
    answerThree3: '管理团队：资产服务方是一支稳定且经验丰富的管理团队，服务于海内外市场各大银行及持牌金融机构。',
    answerThree4: '丰富的资产规模供筛选:提供来自全球消费信贷资产, 累计超30亿美金成交额资产可供基金筛选, 筛选比例约百一份额。',
    answerThree5: '安全垫高:认购人享有基金优先级份额, 基金结构设置20% 劣后资金，资金安全垫高。',
    askedSubTitle4: 'Aurora信息',
    askedFour: '如果投资人认购需要哪些流程和材料？',
    answerFour1: '注意事项：​',
    answerFour2: '请投资人通过海外账户（非中国境内银行账户）支付基金美元投资款；',
    answerFour3: '请投资人按照签约指引的要求签署相关认购材料，并提供如下资料：',
    answerFour4: '1) 划款凭证;',
    answerFour5: '2) 银行账户信息证明(包含 SWIFT 码);',
    answerFour6: '3) 身份证、护照复印件;',
    answerFour7: '4) 三个月内的地址信息证明(如: 水电煤账单、税务/证券/保险/银行账单等均可);',
    answerFour8: '5) 资金证明(持有不少于等价 800 万港币价值的金融产品证明)。'
  },
  contactUs: {
    welcome1: '我们期待与您沟通',
    welcome2: '欢迎与我们联系',
    watch: 'Aurora公众号',
    zhAddress: '大陆办公地址:',
    address1: '上海市黄浦区淮海中路 8 号兰生大厦 1007 室',
    enAddress: '管理人注册地址：',
    address2: 'PO Box 309, Ugland House Grand Cayman KY1-1104, Cayman Islands'
  },
  news: {
    newsModule1: 'Getting Started',
    newsModule2: 'Investment Questions',
    newsModule3: 'Investment Offerings and Selection Process',
    newsModule4: 'XINTAI SPC Information',
    newsModule5: 'Fund Managers',
    newsOne: {
      title: '李彦宏: 从DeepSeek学到一件事, 开源最佳模型能大大促进人们使用',
      overview: '从DeepSeek身上, 我们学到了一件事, 那就是开源最佳模型能大大促进人们使用或采纳这个模型...',
      releaseInfo: '来源：澎湃新闻记者 吴雨欣',
      releaseTime: '2025-02-19 11:16',
      imgDescribe: '百度创始人、董事长兼首席执行官李彦宏。视觉中国 资料图',
      paragraph1: '“从DeepSeek身上, 我们学到了一件事, 那就是开源最佳模型能大大促进人们使用或采纳这个模型。”',
      paragraph2: '2月18日晚, 在百度(Nasdaq: BIDU, 09888.HK)2024年第四季度及全年财报电话会上, 百度创始人、董事长兼首席执行官李彦宏说，开源的决策源自对技术领先地位的坚定信心，开源将进一步促进文心大模型的广泛应用，并在更多场景中扩大其影响力，“但我想强调的是，无论开源还是闭源，基础模型只有在大规模解决现实问题时，才具备真实价值。”',
      paragraph3: '电话会前, 百度发布2024年第四季度及全年财报, 显示2024年总营收达1331亿元, 同比减少1%; 归属百度净利润为237.6亿, 同比增长17%, 不按美国通用会计准则, 归属于百度的净利润为270亿元, 同比下降6%, 每股美国存托股摊薄收益为76.85元, 同比下降5%。',
      paragraph4: '四季度业绩方面, 百度营收为341亿元, 同比下滑2%; 不按美国通用会计准则, 归属于百度的净利润为67亿元, 同比下降13%; 每股美国存托股摊薄收益为19.18元,同比下降12%。',
      paragraph5: '李彦宏在电话会上说, 文心大模型4.5将开源，未来，百度将加速推动文心大模型的性能升级与成本降低。',
      minTitle1: '大模型至今仍未出现杀手级应用',
      paragraph6: '“上一次文心大模型的重要升级是在2023年10月, 距离现在已经有一段时间了, 请大家期待接下来的文心大模型4.5。”李彦宏说, 百度未来计划基于性能提升和成本削减的潜力加速文心大模型的迭代, 也期待看到AI技术带来更多具有突破性的应用。',
      paragraph7: '财报披露, 2024年, 文心大模型日均调用量高速增长, 与去年同期的5000万次相比, 一年增长33倍至16.5亿。近期, 百度宣布将在未来几个月中陆续推出文心大模型4.5系列, 并于6月30日起正式开源; 文心一言自4月1日起全面免费, 所有PC端和APP端用户均可体验文心系列最新模型。2024年12月, 百度文库AI MAU(平均月活跃用户)达到9400万, 同比增长216%, 环比增长83%。公开信息显示, 百度文库付费用户超4000万, 位居全球第二、中国第一。',
      paragraph8: '值得关注的是, DeepSeek与字节跳动旗下豆包也提供搜索功能, 百度搜索与这些AI聊天机器人之间的竞争态势如何?',
      paragraph9: '对此, 百度方面表示, 当前, 约有22%的搜索结果页面包含了AI生成的内容, “我们也在开发能够实现更深层次个性化的能力, 适应每个用户的习惯和偏好。我们的努力已经带来了更好的结果。今年1月, 我们发现, 在百度的月活跃用户中, 83%的用户与生成式AI内容进行互动。去年12月, 百度App上每个用户的搜索查询量同比增长了2%，我们看到用户参与度越来越积极。”',
      paragraph10: '百度高管认为, AI革命仍处于初期阶段, 无论是像DeepSeek这样的AI原生聊天机器人, 还是百度AI驱动的产品, 都是探索AI潜力的不同方式。百度有数亿用户, 有全面的市场视野, 会持续推动创新, 并整合真正创新的AI功能, “虽然AI聊天机器人代表了AI应用发展的一个重要且初期的阶段, 但至今仍未出现杀手级应用。对我们而言, 关键是保持快速而坚定的AI转型步伐, 专注于发现用户真正需要和想要的下一代搜索体验。”',
      minTitle2: 'AI驱动云业务同比增长26%',
      paragraph11: '电话会介绍, 百度的智能云业务在去年四季度营收同比增长26%, 经营利润率持续增长, 2024年, 智能云AI相关收入同比增长近3倍。目前, 百度智能云拥有国内最大的大模型产业落地规模, 为超60%央企和大量民营企业提供AI服务。',
      paragraph12: '李彦宏说, 百度正持续增强千帆大模型平台, 不断改善客户的模型和应用开发体验。千帆大模型平台不仅接入了各种型号的文心大模型, 也提供国内外上百个主流大模型, 并且为所有接入的模型提供后训练、SFT、数据标签和模型准备等工作, 以便为不同的企业提供最合适的模型和工具。',
      paragraph13: '百度方面提供的数据显示, 千帆大模型平台能够在保障任何模型的最佳性能和稳定性的同时, 提供极具竞争力的调用价格。以最新接入的DeepSeek-R1和V3模型为例, 千帆平台上的推理价格最低至DeepSeek官方定价的30%。接入首日, 即有超过1.5万家客户通过千帆平台进行模型调用。',
      paragraph14: '百度预计百度智能云服务的支出将会增加, 因为已观察到一个明显的趋势, 通过千帆大模型平台的API调用而使用基础模型的客户, 也倾向于增加在百度智能云服务上的支出。另有数据显示, 在2024年大模型中标盘点中, 百度智能云在中标项目数、行业覆盖数、央国企中标项目数这三个维度里均为第一。电话会透露, 百度正在成为中腰部客户的首选。',
      minTitle3: '将持续向AI投入',
      paragraph15: '展望2025年, 百度在业务投资方面的战略重点将是什么？如何在搜索、自动驾驶、云服务和基础模型之间分配资源？',
      paragraph16: '对此, 百度方面表示, 百度将继续投资于推进百度AI能力, 这是长期的战略优先事项。基于这一点, 百度将进一步深化AI转型, 特别是在搜索产品的领域, “智能云方面, 我们的目标是推动企业客户对我们人工智能基础设施、飞桨(PaddlePaddle)深度学习平台和文心大模型的采用, 推动市场的增长。在加强技术领导力和加速AI产品及AI云服务在各行业的采用方面, 我们也将继续推进这些优先事项, 来驱动我们的决策。”',
      paragraph17: '李彦宏也在电话会上谈及, 云的强劲增长源自市场对百度AI能力的广泛认可, “我们将持续向AI投入, 以确保处于这一技术趋势的前沿。”',
      paragraph18: '另值得关注的是, 受多重因素影响, 百度的广告业务依然承压, 在四季度也尚未看到明显的改善。2024年, 百度核心(Baidu Core, 即搜索服务与交易服务的组合)收入为1047亿元, 同比增长1%, 其中在线营销收入为730亿元, 同比减少3%。百度第四季度来自百度核心的营收达277亿元, 同比增长1%, 其中, 网络营销营收为179亿元, 同比下滑7%。',
      paragraph19: '据大智慧VIP, 截至美东时间2月18日美股收盘, 百度跌7.51%, 报90.16美元/股。'
    },
    newsTwo: {
      title: '刚刚宣布: 降息50个基点!',
      overview: '2月19日, 新西兰央行将基准利率下调50个基点至3.75%，符合市场预期，为连续第四次会议降息...',
      releaseInfo: '来源： 21世纪经济报道',
      releaseTime: '2025-02-19 12:30:50',
      imgDescribe: '',
      paragraph1: '2月19日, 新西兰央行将基准利率下调50个基点至3.75%，符合市场预期，为连续第四次会议降息。',
      paragraph2: '上述决议公布后，新西兰元兑美元汇率一度直线下挫后迅速反弹。',
      paragraph3: '新西兰货币政策委员会表示, 如果经济条件继续按预期发展, 2025年, 委员会有进一步下调OCR的空间。',
      paragraph4: '数据显示，年度消费者价格指数(CPI)通胀持续处于货币政策委员会1%至3%的目标区间内，核心通胀指标继续向中点靠拢，企业的通胀预期接近目标中点。',
      paragraph5: '委员会指出，一段时间的限制性利率降低了新西兰经济的需求并推动了通胀下降。但全球经济活动疲软、净移民减少以及政府消费下降减缓了国内需求。与全球贸易发展相关的政策不确定性增加也可能减少商业投资。',
      paragraph6: '新西兰统计局此前公布的数据显示, 第四季度失业率升至5.1%, 达到2020年第三季以来最高水平。此外, 第四季度就业人数下降0.1%, 为2009年以来最大降幅。',
      paragraph7: '新西兰失业率创下四年新高, 同时劳动力成本增长放缓, 这支持了新西兰央行将在本月稍晚进一步降息50个基点的预期。',
      paragraph8: '据中国基金报报道, 高盛首席经济学家安德鲁·博亚克表示, 新西兰联储将在上半年连续降息, 包括在本周的政策会议上再降息50个基点。预计新西兰联储将从4月开始, 将每次会议的降息速度放缓至25个基点, 最终官方现金利率在7月达到3.0%的水平。不过, 如果近期调查数据的改善不能转化为经济的改善, 那么降息速度更快、幅度更大的风险就会出现。',
      minTitle1: '澳洲联储四年来首次降息',
      paragraph9: '当地时间18日, 澳大利亚储备银行(以下简称“澳洲联储”)宣布将基准利率下调25个基点, 降至4.1%。这是澳洲联储自2020年11月以来首次下调利率。',
      paragraph10: '决议公布后，澳元短暂上涨后回吐涨幅。',
      paragraph11: '澳洲联储在声明中表示, 通胀膨胀率自2022年达到高点以来已经大幅下降, 因为更高的利率一直在努力使总需求和供应更接近平衡。但澳洲联储同时强调, 通胀上行风险仍然存在。',
      paragraph12: '澳洲联储表示，后续是否降息还将动态评估：“尽管今天的政策决定认可了通胀方面的可喜进展，委员会对进一步政策宽松的前景仍持谨慎态度，将继续依赖数据和对风险的动态评估来指导其决策。”',
      paragraph13: '当前，大多数国家央行一直在放松货币政策，因为他们对通胀正在可持续地回到各自的目标更有信心。但近几个月来，市场对进一步宽松政策的预期有所缓和，尤其是美国。'
    },
    newsThree: {
      title: '金融科技“出海”迎来风口！',
      overview: '金融科技“出海”迎来风口，“一带一路”国家及地区成“新蓝海”...',
      releaseInfo: '来源： 中国基金报记者郭玟君',
      releaseTime: '',
      imgDescribe: '',
      paragraph1: '近年来，在推进高水平对外开放和共建“一带一路”不断深化的背景下，金融科技“出海”迎来了新风口。',
      minTitle1: '“一带一路”国家和地区',
      minTitle2: '成金融科技出海“新蓝海”',
      paragraph2: '近日, 中国基金报记者在微众银行“媒体开放日”了解到, 该行在香港设立的科技子公司——微众科技有限公司(以下简称微众科技)成立仅半年多, 已与香港、印尼、泰国、马来西亚等地超过20家机构展开合作洽谈, 达成数千万美元合作意向。',
      paragraph3: '香港特区政府投资推广署（以下简称投资推广署）金融服务及科技、可持续发展环球总裁梁瀚璟高度评价微众科技的贡献，他说：“微众科技助力富融银行核心系统换新，树立了香港银行数字化典范。”',
      paragraph4: '据介绍, 微众科技成立于2024年6月, 是中国银行业首家在境外直接设立的科技子公司。微众科技秉持“立足香港，致力科技输出，向全球客户提供数字金融和数字基建解决方案”的使命初心，以自主可控技术参与国际市场高水平竞争，提升共建“一带一路”国家和地区的金融数字化能力，支持当地数字经济的发展。',
      paragraph5: '金融科技“出海”正迎来前所未有的发展机遇。微众科技香港有限公司董事魏轲表示，普惠金融、产业数字化及数字化转型，是全球金融行业的共同需求，为金融科技出海提供了巨大商机。',
      paragraph6: '“一带一路”沿线国家和地区，尤其是东南亚地区，凭借其庞大的年轻人口基数、快速增长的数字经济以及日益开放的市场环境，成为全球金融科技企业眼中的“新蓝海”。',
      paragraph7: '据华为云全球销售金融行业负责人徐斌介绍，全球互联网金融市场增量主要集中在亚拉非等新兴市场。华为云初创生态发展总监邓泉介绍，华为云针对全球初创企业推出了赋能加速计划，该计划整合华为内外部生态资源，为初创企业提供全方位支持，推动其商业成功。',
      minTitle3: '香港发挥“超级联系人”优势',
      minTitle4: '助力内地金融科技企业“出海”',
      paragraph8: '香港作为祖国的“超级联系人”和“超级增值人”，在助力内地企业“走出去”方面发挥了重要作用。',
      paragraph9: '据梁瀚璟介绍, 香港已有超过1100家金融科技企业, 业务涵盖多个范畴。除了促成国际合作，香港还为初创企业和金融科技公司提供多元专业服务，并提供广泛的人脉网络和解决方案。这些优势加上蓬勃发展的金融科技和创科生态圈、多元丰富的融资渠道、与主要海外市场接轨的监管制度，为助力内地金融科技出海奠定了基础。',
      paragraph10: '梁瀚璟告诉记者, 2024年, 投资推广署联同香港特区政府财经事务及库务局等机构率领香港财金及金融科技界代表团到访中东，不少在港落户的内地金融科技企业随团出访。此行为他们打开了对接当地政商机构的大门，其中一些企业因此加快了拓展中东市场的步伐。',
      paragraph11: '梁瀚璟介绍, 2025年, 香港两大旗舰盛事——香港金融科技周和StartmeupHK创业节迎来十周年庆, 投资推广署将两大盛事安排在11月3日至7日联合举行, 旨在打造多元化融资平台，将为有意出海的内地企业，尤其是金融科技企业拓展海外业务提供丰富资源。',
      minTitle5: '深圳成立联盟',
      minTitle6: '“领头雁”引领企业“抱团出海”',
      paragraph12: '据深圳市金融科技协会相关负责人介绍, 为响应国家“走出去”号召, 加速深圳金融科技企业的全球布局, 在深圳市委金融办、福田区政府指导下, 2024年10月, 深圳市金融科技协会组建了深圳金融科技出海联盟（以下简称联盟）。',
      paragraph13: '联盟负责人表示, 中资金融机构正积极拓展海外市场, 联盟成员将凭借服务这些机构的经验优势, 伴随中资金融机构的出海步伐, 一同拓展海外业务。此外, 联盟还将充分利用已成功出海成员的“领头雁”作用, 助力其他成员在海外市场的开拓, 通过团结协作, 形成一系列综合性的解决方案, 以高效应对东南亚金融行业面临的IT能力欠缺、基础设施薄弱及落地能力不足等关键问题。',
      paragraph14: '该负责人还透露, 今年的出海活动丰富多彩, 包括香港金融科技周、新加坡金融科技节、深港澳金融科技峰会、The GBA Day系列活动, 以及定期举办的金融科技企业出海专场对接会等。'
    },
    newsFour: {
      title: '美联储降息预期升温',
      overview: '自美国总统特朗普正式就职以来，加拿大、墨西哥和中国成为最先被加征关税的对象...',
      releaseInfo: '',
      releaseTime: '',
      imgDescribe: '',
      paragraph1: '自美国总统特朗普正式就职以来, 加拿大、墨西哥和中国成为最先被加征关税的对象。此外, 特朗普还威胁对欧盟商品加征更多关税, 并宣布对从所有国家进口的钢铝加征25%的关税。受特朗普关税政策影响, 今年以来, 大宗商品价格整体震荡下行, 其中原油、煤炭、建材、钢铁等板块跌幅居前。由于近期公布的美国经济数据走弱, 市场上调了对美联储未来降息幅度的预期, 重新押注年内降息3次, 预计首次降息的时间提前至6月。',
      paragraph2: '从经济领先指标来看, 美国3月密歇根大学消费者信心指数降至57.9, 前值为67.8, 连续3个月下滑, 创2023年6月以来新低; 美国3月Sentix投资信心指数由21.2降至-2.7, 为2023年8月以来首次转负; 美国3月纽约联储制造业指数由5.7降至-20, 为2024年2月以来新低。3月17日, 经合组织发布最新经济展望报告, 将2025年全球经济增长预期由3.3%下调至3.1%, 预计美国和欧元区2025年经济增速分别为2.2%和1%, 较此前预期分别下调0.2和0.3个百分点。由此可见，特朗普的关税政策可能引发更多贸易摩擦，各国之间互相加征关税将增加商品流通成本，破坏产业链稳定，打击国际贸易活动并抑制大宗商品需求，从而威胁全球经济增长前景。',
      paragraph3: '就业方面, 美国2月新增ADP就业7.7万人, 远低于上月的18.6万人和预期的14万人, 创2022年2月以来新低。新增非农就业15.1万人, 前值为12.5万人, 略低于预期的16万人, 失业率由4%上升至4.1%。平均小时工资同比增长4%, 低于预期的4.1%。数据表明，受美国政府部门裁员、驱逐非法移民等因素影响，企业减少了招聘计划，导致非农就业增长放缓。但劳动力市场依然稳健，工资保持温和增长，整体处于充分就业状态。',
      paragraph4: '通胀方面, 美国2月CPI同比由3%降至2.8%, 为去年9月以来首次回落, 环比上涨0.2%, 低于预期的0.3%; 核心CPI由3.3%降至3.1%, 低于预期的3.2%。分项数据显示, CPI降温主要受汽油价格下跌以及食品价格涨幅回落影响, 但剔除能源和食品价格后的核心通胀依然较高, 住房成本尤其是租金价格居高不下, 服务通胀的黏性凸显。根据美国密歇根大学调查数据, 1年期通胀预期由4.3%上升至4.9%, 连续4个月加速增长, 创2022年11月以来新高。考虑到美国对进口钢铝加征关税的政策已于3月12日落地, 对等关税最早将于4月2日实施, 美国部分企业已经提前涨价, 实际影响可能会在3月的通胀数据中体现。因此, 美联储不会因为一个月的数据而改变当前货币政策立场, 需要等待更多有利证据。在确信通胀可以回到2%的目标之前, 利率将在一段时间内保持不变。',
      paragraph5: '综上所述, 美国经济增长放缓, 但劳动力市场具有韧性, 通胀反弹的风险尚未解除。特朗普的关税政策在推高通胀预期的同时打压了消费者信心并抑制消费支出, 引发市场对美国经济可能陷入滞胀的担忧, 导致美联储年内降息的预期升温。近期, 美联储主席鲍威尔发表讲话称, 政策利率处于合理水平, 在特朗普政府关税政策的影响进一步明晰之前, 不急于降息。美联储此举是在进行预期管理, 强调实现通胀目标的不确定性增加, 需要对当前政策保持耐心, 以便更加全面地评估特朗普政府关税政策的潜在影响, 避免利率曲线落后于经济形势。我们认为, 在对实现通胀目标更有信心之前, 美联储上半年维持利率不变的可能性较大, 除非经济持续走弱或劳动力市场意外疲软。进入下半年, 随着“关税战”的负面影响进一步显现, 全球经济下行压力或将加大, 美联储货币政策有望重回降息通道, 预计降息时间最早在7月底, 全年降息2到3次。',
      paragraph6: '今年上半年，考虑到特朗普政府关税政策的不确定性，贸易摩擦升级的风险加大，全球经济将面临严峻挑战。美联储货币政策将在未来一段时间进入观察期，全球贸易活动放缓将削弱大宗商品需求；展望下半年，美联储有望重新开启降息操作，并停止缩减资产负债表。在全球央行新一轮货币宽松的推动下，大宗商品需求有望回暖，商品价格或迎来阶段性反弹。'
    },
    newsFive: {
      title: '美国频加关税 多国人士共商亚太应对之道',
      overview: '“(加征)关税不会解决美国的财政赤字问题。”美国经济学家杰弗里·萨克斯27日在博鳌亚洲论坛2025年年会上说...',
      releaseInfo: '来源： 中国新闻网',
      releaseTime: '2025年03月28日 11:15',
      imgDescribe: '3月27日, 博鳌亚洲论坛2025年年会“美国外交政策走向及其对亚太合作影响”分论坛在海南博鳌举办。官逸伦摄',
      paragraph1: '“(加征)关税不会解决美国的财政赤字问题。”美国经济学家杰弗里·萨克斯27日在博鳌亚洲论坛2025年年会上说。',
      paragraph2: '在当日举行的“美国外交政策走向及其对亚太合作影响”分论坛上，与会嘉宾围绕美国加征关税等展开深入交流。',
      minTitle1: '美政策遭多方质疑',
      paragraph3: '近日, 美国总统特朗普签署公告, 宣布对进口汽车加征25%关税。',
      paragraph4: '萨克斯指出了特朗普政府政策逻辑存在的缺陷：他们试图通过对富豪减税来刺激经济，又指望用关税收入弥补财政缺口，这种政策组合难以奏效，最终受害的还是美国普通民众。',
      paragraph5: '美国前商务部长卡洛斯·古铁雷斯称，特朗普政府一系列加征关税的举措是“战术性行为”。当前，美国政府将全球治理体系视为威胁，认为这会妨碍美国的发展。',
      paragraph6: '中国前驻美大使周文重在论坛上呼吁美方停止“损人不利己”的贸易战、关税战。他表示，美国现在面临的很多问题，都是自身产业空心化及经济金融化造成的，特朗普政府不应“甩锅”，应从自身寻求解决方案。',
      paragraph7: '国际信用评级机构穆迪公司本月25日预计, 美国债务占国内生产总值(GDP)的比重将从今年的接近100%升高到2035年的130%左右。',
      minTitle2: '亚洲各国积极应对',
      paragraph8: '中国前驻美大使崔天凯表示，在经济快速发展、经济结构大调整的背景下，怎么解决好社会公平、保持文化特性、维护自然环境、维护地区和世界和平，这些“才是人类共同面对的问题”。',
      paragraph9: '新加坡国立大学亚洲研究所研究员马凯硕提醒，当前正处于人类历史上发生重大变革的时期，今天的世界是多文化的、多极的、多边的，亚洲内部存在一定挑战，“但亚洲人必须找到办法应对这些困难”。',
      paragraph10: '英国《经济学人》国际执行主编帕特里克·福利斯呼吁亚洲内部要避免贸易战，且从长期看，亚洲国家需要签署更多自由贸易协定。',
      paragraph11: '崔天凯说，亚太地区要坚持此前的成功经验：相互尊重、强调共同利益、用和平方式解决可能的分歧等。不管其他国家如何调整政策，亚太地区国家要守住初心，保持传统，发扬优势。如此，不管世界发生什么变化，亚太地区才能有光明的前景。(完)'
    },
    newsSix: {
      title: '再次冲上热搜! 金价一度突破3290美元, 中期仍有上涨空间',
      overview: '4月16日, 现货黄金快速拉升, 截至中午突破3290美元/盎司关口，再创历史新高。“金价”也再次冲上热搜...',
      releaseInfo: '来源： 界面新闻',
      releaseTime: '2025年04月16日 13:31',
      imgDescribe: '',
      paragraph1: '4月16日, 现货黄金快速拉升, 截至中午突破3290美元/盎司关口，再创历史新高。“金价”也再次冲上热搜。',
      paragraph2: '与此同时, 国内品牌金饰价格仍维持在历史高位。周生生足金饰品价格突破千元每克, 报价来到1007元/克; 周大福和周六福的足金饰品价格均为990元/克。',
      paragraph3: '消息面上，因美国总统特朗普对关键矿产发起调查，市场避险情绪升温。不断升级的贸易担忧情绪使投资者持续撤离风险资产，转向避险资产。',
      paragraph4: '分析人士预计在全球政经不确定性未消的背景下，金价中期仍具上行潜力。',
      paragraph5: '面对黄金价格的再度突破, 市场对其未来是否会重演“V型”走势格外关注。国是金融改革智库首席专家刘胜军向媒体分析, 此前黄金价格的剧烈波动主要源于市场观点的分歧。当黄金价格在短时间内快速上涨后，部分投资者会选择获利了结，这种现象属于市场正常表现。',
      paragraph6: '“但从长远来看，受国际局势的复杂性以及美国政策不确定性的影响，市场避险需求依然强劲，各国央行尤其是中国央行的持续购金行为也在支撑黄金价格。 黄金价格涨势远没有结束，未来四年内仍有较大涨幅空间 ，”刘胜军分析认为。',
      paragraph7: '从央行购金数据来看, 2022年, 全球央行净购买1082吨黄金, 相较于此前的450吨大幅提升, 创下历史最高。2023年, 再度净购买1037.4吨, 接近全年黄金供应量的20%。',
      paragraph8: '截至2024年3月, 中国央行黄金储备为7274万盎司, 环比继续上升16万盎司。值得注意的是, 这已经是中国央行连续第17个月增加, 累计增持高达1010万盎司, 约合286吨。',
      paragraph9: '美国前财政部长劳伦斯·萨默斯在接受采访时表示， 美国总统特朗普反复无常的政策行动和言论正在侵蚀全球市场对美元的信任，金价的大幅上涨正是这种不确定性的体现 。',
      paragraph10: '当地时间4月15日, 美国银行发布的调查报告显示，在过去两个月内， 全球投资者创纪录地大幅减持美国股票 。在美国银行对基金经理进行的4月月度调查中, 受访的基金经理的美股净仓位减少了36%。 有49%的基金经理表示， “做多黄金”目前是最拥挤的交易策略, 结束了连续24个月的“做多美股科技七巨头”的策略。 61%的基金经理预期美元将在未来12个月内贬值, 这是2006年5月以来的最高水平。',
      paragraph11: '华尔街巨头们也纷纷大幅上调黄金的价格展望。',
      paragraph12: '高盛在最新报告中将2025年黄金目标价从此前的每盎司3300美元上调至3700美元, 上调幅度高达12%，也是该机构年内最激进的一次上调动作 。',
      paragraph13: '瑞银预计, 由于全球贸易和地缘政治背景的变化增强了避险资产的配置需求, 该行分析师Joni Teves预计, 金价到2025年12月将达到每盎司3500美元。',
      paragraph14: '德银的预测则显示, 到2025年底, 黄金价格将达到3350美元/盎司; 如果央行需求在2025年底前保持高位但随后回落至2011—2021年的常态, 2026年黄金平均价格可能为3500美元/盎司; 如果高需求持续到2026年底, 则2026年平均价格可能达到3900美元/盎司。'
    },
    newsSeven: {
      title: '王沪宁会见印尼人民协商会议副主席艾迪',
      overview: '新华社北京4月15日电 全国政协主席王沪宁15日在京会见印尼人民协商会议副主席艾迪...',
      releaseInfo: '来源： 新华社',
      releaseTime: '2025年04月15日 17:18',
      imgDescribe: '',
      paragraph1: '新华社北京4月15日电 全国政协主席王沪宁15日在京会见印尼人民协商会议副主席艾迪。',
      paragraph2: '王沪宁表示，中国和印尼传统友谊深厚，在两国元首战略引领下，中印尼关系进入共建中印尼命运共同体新阶段。中方愿同印尼一道，落实两国元首重要共识，加强战略协作，共同弘扬和平共处五项原则和万隆精神，为促进地区和世界发展、繁荣、稳定作出更大贡献。中国全国政协愿同印尼人民协商会议加强交流交往，为中印尼命运共同体建设作出新贡献。',
      paragraph3: '艾迪表示, 愿以两国建交75周年为契机, 继续深化两国合作，推动双边关系不断迈上新台阶，为世界和平稳定作出积极贡献。印尼人民协商会议愿同中国全国政协加强交流合作，为增进两国各领域务实合作和人民友好增添动力。',
      paragraph4: '王东峰等参加会见。'
    },
    newsEight: {
      title: '三大官员齐发声: 美联储已准备“摆烂式”观望至9月?',
      overview: '纽约联储主席威廉姆斯 (John Williams) 表示, 在面对不确定的经济前景之际, 货币政策决策者可能尚未准备好在9月份之前降低利率...',
      releaseInfo: '来源： 财联社',
      releaseTime: '2025年05月20日 01:23',
      imgDescribe: '',
      paragraph1: '纽约联储主席威廉姆斯 (John Williams) 表示, 在面对不确定的经济前景之际, 货币政策决策者可能尚未准备好在9月份之前降低利率。',
      paragraph2: '当地时间周一 (5月19日) , 威廉姆斯表示,“我们不可能在6月份或7月份就能搞清楚情况。这将是一个持续收集数据、逐步厘清形势、观察发展趋势的过程。”',
      paragraph3: '美联储接下来的三次会议将分别在6月、7月和9月举行。根据联邦基金期货的定价, 市场目前预计今年将有两次25个基点的降息, 低于4月底时预期的四次。',
      paragraph4: '因为在特朗普暂停对等关税90天后, 衰退和降息的几率都有所减少。目前, 芝商所的“美联储观察”工具显示, 该行6月降息的概率不到10%, 7月前采取行动的概率略超33%。',
      paragraph5: '威廉姆斯强调，不确定性不仅困扰着政策制定者，也让企业和家庭难以判断特朗普政府包括关税在内的一系列政策将如何重塑美国经济。和许多同僚一样，威廉姆斯表示，美联储可以耐心等待新数据。',
      paragraph6: '威廉姆斯指出，虽然通胀正在回落，经济也接近充分就业，但他正在密切关注贷款违约情况以及消费者支出意愿。他还表示，当前的货币政策“略微具有抑制性”，处于“不错的位置”。',
      paragraph7: '日内早些时候, 亚特兰大联储主席博斯蒂克 (Raphael Bostic) 也表达了类似的态度，即短期内不打算调整利率。',
      paragraph8: '“经济处于极大波动中，政策也在不断变化，不确定性很高。我认为我们需要等待三到六个月，才能看到事态如何发展。”',
      paragraph9: '博斯蒂克称他特别担忧通胀以及公众对未来物价上涨的预期，“考虑到我们的双重使命，我更多地担心通胀，尤其是因为我们看到通胀预期出现了令人担忧的变化。”',
      paragraph10: '发稿前不久, 美联储副主席杰斐逊 (Philip Jefferson) 也强调了“观望”立场。他表示，美联储必须确保物价上涨不会演变为持续性的通胀。'
    },
    newsNine: {
      title: 'DOCKING TECH成功发行首单Repo, 携手滴灌通澳交所与全球顶尖承销商共拓融资新生态',
      overview: '我司主体 DOCKING TECH PTE. LIMITED (以下简称“DOCKING TECH”), 作为印尼持牌金融机构BANTUSAKU的superlender...',
      releaseInfo: '原创 公众号：出海瞭望塔',
      releaseTime: '2025年5月22日',
      imgDescribe: '',
      paragraph1: '我司主体 DOCKING TECH PTE. LIMITED (以下简称“DOCKING TECH”), 作为印尼持牌金融机构BANTUSAKU的superlender, 近日在全球首家持牌收入分成交易所——Micro Connect (滴灌通澳交所, 简称MCEX) 上成功发行首单Repo (回购协议), 标志着公司在资本运作与技术创新融合领域实现里程碑式突破。本次发行由国际知名投行GOLDEN EAGLE BROKERAGE LIMITED (金鹰证券) 与深耕亚太市场的PANDA SECURITIES COMPANY LIMITED (熊猫证券) 联合承销，以全球化资源与本土化专业能力为项目高效落地注入强劲动能。',
      paragraph2: '滴灌通澳交所 (MCEX): 全球首创收入分成模式，重塑中小企业融资范式',
      paragraph3: '作为本次Repo发行的核心平台, Micro Connect (滴灌通澳交所) 凭借其全球首创的“收入分成交易”模式与持牌交易所的合规优势，正在重新定义资本与实体经济的链接方式。',
      paragraph4: '背景与定位：\n 滴灌通澳交所 (MCEX) 是全球首家获得监管批准（由澳门金融管理局许可）的收入分成交易所，以“让资本精准灌溉小微企业”为使命，专注于为中小企业提供轻结构、低成本、可规模化的融资解决方案。平台通过数字化技术重构传统金融核心元素，将“收入权”转化为可流通、可定价的金融标的，彻底打破传统融资对固定资产抵押的依赖。',
      paragraph5: '创始力量：顶尖金融家掌舵，定义产融新规则',
      paragraph6: '创新合作模式：\n李小加\n滴灌通联合创始人、香港交易所前行政总裁, 被誉为“中国资本市场国际化推手”。任内主导沪港通、深港通等里程碑项目，推动中概股回归与“同股不同权”上市改革。其“让资本与实体经济毛细血管连通”的理念，成为滴灌通收入分成模式的底层逻辑。',
      paragraph7: '张高波\n滴灌通联合创始人、东英金融集团创始人, 深耕跨境资本运作逾30年。作为最早参与中国国企海外上市的投行家之一, 其“技术解构金融风险”方法论，驱动滴灌通构建数据驱动的风控体系，实现小微资产与全球资本的安全高效匹配。',
      paragraph8: '创新合作模式\n收入分成合约 (DRC) \n滴灌通首创每日收入分成合约(Daily Revenue Contract, DRC), 企业通过出让小额、灵活的未来收入权益获取资金, 无需承担固定负债。DOCKING TECH此次发行的Repo即基于DRC衍生设计, 既保留了收入分成模式的灵活性，又通过回购协议锁定融资成本与期限，实现风险可控的资金周转。',
      paragraph9: '数字化投融资载体\n平台利用区块链与智能合约技术, 将企业门店级收入数据实时上链，通过动态算法自动完成每日收入分成，确保资金流向透明、分账高效。投资者可通过交易所买卖“收入权证”，获得流动性支持，企业则能以极低摩擦成本触达全球资金。',
      paragraph10: '交易所级流动性支持\n作为持牌交易所, MCEX为DRC及衍生品提供标准化交易、清算和风控体系, 吸引多元机构投资者参与。DOCKING TECH的Repo产品凭借其底层技术资产的高成长性, 在交易所内迅速形成流动性溢价，为企业融资效率提升注入“乘数效应”。',
      paragraph11: '核心价值突破：\n轻资产融资:企业无需抵押厂房、设备，仅凭技术能力与收入潜力即可融资；\n成本可控: 收入分成比例根据业务波动动态调整，避免刚性兑付压力；\n生态共赢: 投资者通过交易所分享企业成长红利，企业则获得“造血式”资本支持。\n强强联手: 全球承销商护航，释放产融协同势能',
      paragraph12: '本次Repo发行汇聚两大顶尖承销商——GOLDEN EAGLE BROKERAGE LIMITED与PANDA SECURITIES COMPANY LIMITED, 形成“全球化+本土化”双轮驱动格局：',
      paragraph13: 'GOLDEN EAGLE BROKERAGE LIMITED: 国际顶尖跨境投行, 专注科技企业全球化资本布局。凭借其广泛的国际投资者网络与跨境结构化融资经验, 助力DOCKING TECH高效对接主权基金、科技产业资本等长期资金, 为全球化技术布局夯实基础。',
      paragraph14: 'PANDA SECURITIES COMPANY LIMITED: 亚太科技金融领军券商，全牌照资质与区域合规能力双驱动。依托对亚太监管环境与投资者偏熟的深度理解，主导发行结构设计、合规路演及定价策略，确保项目既符合国际标准，又精准匹配区域市场需求。',
      paragraph15: '行业启示：收入分成模式或颠覆科技企业融资逻辑\n在美联储加息周期与全球资本避险情绪升温的背景下, 轻资产、高弹性的收入分成模式正成为科技企业融资的破局利器:\n从“债权思维”到“共赢思维”: 投资者从企业收入增长中直接获益，与企业风险共担、利益共享;\n从“融资难”到“融资智”: 技术驱动型公司可绕过传统评级体系，凭真实业务数据获得资本认可。',
      paragraph16: '展望未来：定义金融流动性新范式，构建全球资本链接枢纽\n此次Repo发行是DOCKING TECH与滴灌通澳交所重塑数字金融生态的起点。未来, 双方将围绕两大战略方向深化合作：\n融资模式轻量化;基于滴灌通DRC (每日收入分成合约）的灵活架构，通过数据驱动的风控模型实现资产端与资金端的精准匹配；\n资本链路全球化: 联合GOLDEN EAGLE、PANDA等机构开发多币种融资通道, 降低跨境资金摩擦成本，扩大东南亚、中东等新兴市场的资本触达半径；',
      paragraph17: '作为数字金融赛道的创新实践者, DOCKING TECH将持续以技术赋能资本流动效率, 让每一份收入权都成为撬动增长的支点。'
    },
    newsTen: {
      title: 'Cubix Capital 携集团新成员 EasyBank 亮相巴厘岛嵌入式金融论坛：聚焦金融科技与实体融合，解锁合规创新密码',
      overview: '2025 年 8 月 25 日, “金融科技借贷、印尼人民信贷银行 (BPR) 与商业银行的合作” 嵌入式金融全国论坛在巴厘岛举办...',
      releaseInfo: '原创 公众号：出海瞭望塔',
      releaseTime: '2025年8月29日',
      imgDescribe: '',
      minTitle1: '嵌入式金融论坛：金融科技 + BPR, 巴厘岛解融资困局',
      paragraph1: '2025 年 8 月 25 日, “金融科技借贷、印尼人民信贷银行 (BPR) 与商业银行的合作” 嵌入式金融全国论坛在巴厘岛举办, 印尼金融服务管理局 (OJK) 、网络借贷运营商等约 100 名从业者参会, 核心聚焦东南亚普惠金融缺口, 以 “传统金融 + 金融科技” 协同破局。',
      paragraph2: '当前，东南亚个体经营者、自由职业者等个人群体及超微企业，因缺传统信贷资质，难获 100 万 - 500 万印尼盾资金。论坛明确，网络借贷平台与 BPR 合作是关键方案，且成效已显：截至 2025 年 6 月，网络借贷放贷总额超 83 万亿印尼盾, 20 万亿流向含大量个人客户的超微型群体，单笔均值 100-200 万印尼盾。',
      paragraph3: 'Cubix Capital 旗下 Bantusaku 是合作核心力量，其首席执行官 Arnoldyth Rodes Medo提到, 通过第三方生态整合、API 设计等, 能与 BPR 高效合作, 2025 年 1-8 月已向巴厘岛放贷 955 亿印尼盾, 全国累计放贷 20.8 万亿印尼盾。同时, 合作严守风控, 网络借贷平台均接入 OJK 的 SLIK 系统, 不良贷款率 (NPL) 低于 3%, 筑牢合作基础。',
      minTitle2: 'Cubix Capital 添新员 EasyBank, 创始人赴会共探行业路',
      paragraph4: '此次巴厘岛嵌入式金融论坛，不仅是行业交流的平台，更成为 Cubix Capital 集团展示战略布局的重要契机 —— 集团正式宣布 EasyBank 成为新业务成员，且 EasyBank 创始人 Rafif Rizqulloh 受邀出席论坛，深度参与金融科技与传统金融协同发展的议题讨论，为行业实践贡献新视角。',
      paragraph5: 'EasyBank 的诞生贴合数字时代用户需求，成立初衷为 “在当今数字世界，让财务管理更简单、更贴合实际需求”。其洞察到数字经济下用户对金融服务便捷性、适配性要求提升，而传统服务流程繁琐、场景适配不足的痛点，依托印尼大型在线借贷平台经验，聚焦用户诉求，打造 “快捷、无繁琐流程、可信赖” 的服务体系，适配个体经营者小额调度、普通用户日常理财等场景。',
      paragraph6: '论坛期间, Rafif Rizqulloh 提出, 印尼人民银行 (BPR) 有本地根基但放贷速度慢, 网络借贷平台凭技术能优化流程, 二者深度合作并借混合数据构建信贷评分方案, 可补 BPR 效率短板、扩服务覆盖, 实现 “1+1>2”, 该观点契合论坛 “协同创新” 主题，也为 EasyBank 后续业务合作铺垫。',
      minTitle3: 'EasyBank 加盟赋能, Cubix Capital 集团业务升级焕新',
      paragraph7: 'EasyBank 的加入，是 Cubix Capital 集团东南亚金融科技战略的关键升级，从业务协同、市场竞争力、战略纵深三方面注入新动能。',
      paragraph8: '业务协同上，旗下 Bantusaku 聚焦用户 “融资需求”, 通过技术赋能解决传统金融覆盖不足问题: EasyBank 主打 “日常财务管理”，覆盖消费、储蓄等场景，二者形成 “融资 + 管理” 互补，构建用户全金融生命周期服务链，推动集团服务从 “单点满足” 升级为 “全场景覆盖”，提升用户粘性与品牌竞争力。',
      paragraph9: '市场竞争力层面, EasyBank 助力集团把握东南亚数字金融机遇。当前区域内用户对 “轻量化”“场景化” 金融需求激增, EasyBank 依托成熟经验与需求聚焦优势，借集团风控体系（接入 OJK 的 SLIK 系统、运用 Cloudun AI 技术）保障合规，还通过灵活产品适配场景，形成差异化优势，巩固行业地位。',
      paragraph10: '战略纵深维度, EasyBank 深化集团 “技术 + 生态” 战略。其承接集团既有技术成果，收集用户行为数据反哺研发，同时带动跨境支付、绿色金融等领域布局，以 “以点带面” 延伸业务生态，增强韧性与成长性，为集团深耕东南亚金融科技市场奠基。',
      paragraph11: '随着巴厘岛实践落地、Cubix Capital 区域布局推进及集团业务升级，金融创新渐成燎原之势。未来，金融科技与传统银行深度融合下，东南亚金融服务覆盖将更广泛，精准渗透数字经济、新消费等领域，激活市场潜能、重塑行业生态，在合规与创新平衡中为更多主体注入活力，助力区域经济发展，也为行业提供协同合作范例。',
      minTitle4: '关于 Cubix Capital',
      paragraph12: '积序资本 2019 年由 JP 摩根、中金支付等机构高管联合创立, 7 年深耕全球市场，持多国金融牌照合规经营，管理资产规模破亿美元，业务稳居行业头部，是全球化的专业资产服务集团。'
    },
    newsEleven: {
      title: '美联储降息大消息！特朗普最新发声：幅度会很大！',
      overview: '关键时刻，特朗普向美联储“极限施压”...',
      releaseInfo: '来源： 证券时报网',
      releaseTime: '2025年09月15日',
      imgDescribe: '',
      paragraph1: '关键时刻，特朗普向美联储“极限施压”。',
      paragraph2: '在9月议息会议前夕, 美国总统特朗普表示, 美联储将在此次会议上实施9个月以来的首次宽松政策, 他预期美联储会“大幅降息”。与此同时, 特朗普政府再度敦促美国上诉法院批准解雇美联储理事库克。',
      paragraph3: '目前来看, 市场已经确信美联储将会至少降息25个基点, 但降息50个基点的难度很大。据CME“美联储观察”, 美联储本周降息25个基点的概率达96.4%, 降息50个基点的概率仅为3.6%。有分析指出，本周美联储会议声明的措辞、利率点阵图以及投票结果，将是判断美联储未来货币政策走向的关键。',
      minTitle1: '“降息幅度会很大”',
      paragraph4: '美东时间9月14日, 美国总统特朗普表示, 美联储本周将举行一次关键会议, 美联储预计将在此次会议上实施九个月来的首次宽松政策, 届时美联储将“大幅降息” 。',
      paragraph5: '“我认为美联储的降息幅度会很大, ”特朗普周日返回华盛顿途中对记者表示：“现在正是降息的最佳时机。”',
      paragraph6: '根据日程安排, 美联储将于本周 (9月16日至17日) 召开议息会议, 届时将决定是否降息。市场一致认为, 该央行将在此次会议上进行今年以来首次降息。',
      paragraph7: '谈及下一任美联储主席人选, 特朗普称：“我有三个非常看好的人。”',
      paragraph8: '在议息会议前夕, 特朗普政府再度敦促美上诉法院批准解雇美联储理事库克。',
      paragraph9: '据央视新闻, 特朗普于当地时间9月14日向美国上诉法院提出最后请求, 要求允许其解雇美联储理事库克, 理由是她涉嫌房贷欺诈。特朗普希望在下周美联储利率决议前完成此举, 并再次强调库克至今未能对相关指控作出有力反驳。',
      paragraph10: '特朗普政府在美国东部时间周日 (9月14日) 下午3点的最后期限前向哥伦比亚特区上诉法院提交了请求。',
      paragraph11: '特朗普政府称, 库克要求继续留在理事会的请求“毫无根据”, 对于库克是否在财务问题有所误导的担忧, 引发了人们对于“在管理美国货币供应方面, 能否信任库克做到坦诚、审慎且公正行事”的疑虑。',
      paragraph12: '特朗普在8月25日以涉嫌住房抵押贷款欺诈为由解雇美联储理事库克。这也是美联储100多年来首次有理事被总统解职。库克随后对特朗普提起诉讼, 称特朗普无权将她解职。',
      paragraph13: '当地时间9月9日, 华盛顿特区美国地方法院法官贾·科布作出初步裁定, 暂时阻止特朗普罢免美联储理事库克。',
      paragraph14: '特朗普上周三就联邦法官阻止他解雇库克的裁决提起上诉。9月12日, 美国司法部请求华盛顿三名法官组成的小组发布“暂缓执行令”, 要求上诉法院在15日之前作出裁定。',
      paragraph15: '当前的关键在于, 在本周的议息会议前, 美联储理事会的构成是否会发生变化。只要联邦法官的裁决有效, 库克就能参加会议。而这可能会对特朗普的降息计划构成潜在阻碍。',
      minTitle2: '降息50个基点的可能性',
      paragraph16: '针对本周的议息会议, 市场确信美联储将会至少降息25个基点。据CME“美联储观察”, 美联储本周降息25个基点的概率高达96.4%, 降息50个基点的概率为3.6%;美联储10月累计降息25个基点的概率为16.0%, 累计降息50个基点的概率为81.0%, 累计降息75个基点的概率为3.0%。',
      paragraph17: '目前金融市场普遍倾向于认为, 对就业形势的担忧将在本周利率决议中占据主导地位, 美联储将传达“鸽派”基调。',
      paragraph18: '投资者对美联储将开启一轮降息周期的乐观情绪, 已经将资产价格推至高位。在债券市场, 基准10年期美国国债收益率徘徊在4月份以来的最低点附近。在股票市场, 标普500指数正接近历史高点, 而以科技股为主的纳斯达克100指数在上周五创下新纪录, 并录得一年多来最长的连续上涨。',
      paragraph19: 'Brandywine Global Investment Management债券投资组合经理Jack McIntyre表示:“我的直觉告诉我是25基点。问题在于美联储在声明中是否会更多强调就业而非通胀。”',
      paragraph20: '彭博策略师Michael Ball分析称, 尽管通胀表现出黏性但并未重新加速, 劳动力数据正在走软, 消费支出则保持稳定, 交易员正越来越多地权衡美联储采取更激进宽松路径的可能性, 以及这对美国国债进一步上涨的支持作用。',
      paragraph21: '摩根大通的交易部门警告称, 此次会议可能演变为一次“卖出事实”事件, 导致投资者获利了结并撤回资金。',
      paragraph22: '对于投资者而言, 本周美联储会议声明的措辞、利率点阵图以及投票结果, 将是判断美联储未来政策走向的关键。',
      paragraph23: 'IUR Capital的董事总经理Gareth Ryan认为, 利率点阵图所反映的宽松程度至关重要。如果点阵图确认年底前和2026年第一季度会再度降息, 他预计股市不会有太大反应。如果点阵图对明年第一季度降息的表述不够明确, 那么就为市场出现更大幅度的波动打开了大门。',
      paragraph24: '顾问公司RSM首席经济学家Joe Brusuelas表示, 9月份之后, 黏性通胀可能令美联储保持谨慎。',
      paragraph25: '花旗分析认为, 温和的通胀报告与疲软的劳动力市场信号相结合, 为美联储开启降息周期扫清了障碍。预计美联储将在未来五次议息会议上累计降息125个基点, 政策利率最终可能降至3%以下。'
    }
  },
  compliance: {
    title: '合格投资人须知',
    paragraph1: '在继续浏览本公司网站前，请您确认您或您所代表的机构是一名“合格投资者”。“合格投资者”指根据任何国家和地区的证券和投资法规所规定的有资格投资于私募证券投资基金的专业投资者。例如根据本基金合规的规定，合格投资者的标准如下:',
    paragraph2: '(a) 获托付的总资产不少于 4 千万港元（或等值外币）的信托法团；',
    paragraph3: ' (b) （单独或联同其配偶或子女于某联权共有帐户内）拥有的投资组合不少于 8 百万港元（或等值外币或金融资产）的个人；',
    paragraph4: '(c) 拥有的投资组合不少于 8 百万港元（或等值外币或金融资产）或总资产不少于 4 千万港元（或等值外币）的法团或合伙；及',
    paragraph5: '(d) 唯一业务是持有投资项目及由任何一名符合上文(a)、(b)或(c)段描述的人士全资拥有的法团。 ',
    paragraph6: '如果您进入、访问或使用本网站或本网站内任何网页，即被视为您声明及保证为“合格投资者”，并视为您已同意接受本网站所有条款与条件的约束。本网站所介绍信息、工具和资料仅供一般性参考。除非另有明确协议，并不构成广告、分销、销售要约或招揽买入任何基金或其他投资的任何要约。',
    paragraph7: '投资涉及风险，投资产品的过往业绩并不预示或暗示其未来表现，投资者在做出决策前应认真阅读相关产品合同，向有关税务、法务咨询意见。投资者不应该依赖本网站所提供的资料做出投资决策。',
    paragraph8: '极光投资管理公司对本网站所提供信息的准确性和完整性不做任何保证，也不保证所包含的信息及相关建议不会发生任何变更，本公司已力求材料内容的客观、公正，但文中的观点、结论及相关建议仅供参考，不代表任何确定性的判断',
    paragraph9: '如果确认您或您所代表的机构是一名“合格投资者”，并将遵守适用的有关法规请点击“确认”键以继续浏览本网站。如您不同意任何有关条款，请点击“放弃”'
  }
}
